<template>
  <vs-table :data="allPurchases" class="mt-4 w-full" noDataText="">
    <template slot="thead">
      <vs-th></vs-th>
      <vs-th class="white-txt"><div class="w-full text-right">{{ getMonthFrench(today.getMonth()-2).toUpperCase() + " " + getYearFromMonth(today.getMonth() - 2) }}</div></vs-th>
      <vs-th class="white-txt tr2"><div class="w-full text-right" style="padding-right: 20px;">{{ getMonthFrench(today.getMonth()-1).toUpperCase() + " " + getYearFromMonth(today.getMonth() - 1) }}</div></vs-th>
      <vs-th class="white-txt" style="width: 140px;"><div class="layer-blue"><div></div></div><div class="w-full text-right text-white" style="padding-right: 20px; z-index: 998;">{{ getMonthFrench(today.getMonth()).toUpperCase() + " " + getYearFromMonth(today.getMonth()) }}</div></vs-th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr class="noHover" style="background: transparent;">
        <vs-td style="font-weight:500; padding-left: 20px !important;"><div style="width: 50px; white-space: nowrap;"><span>Total HT<br/></span><span style="color: #08B0B9;">À refacturer</span></div></vs-td>
        <vs-td class="text-right" style="font-weight:500; padding-right: 12px;">{{ lastLastMonthSum }}€<br/><span style="color: #08B0B9;">{{ lastLastMonthRefac }}€</span></vs-td>
        <vs-td class="text-right tr2" style="font-weight:500; padding-right: 12px;"><div style="padding-right: 20px;">{{ lastMonthSum }}€<br/><span style="color: #08B0B9;">{{ lastMonthRefac }}€</span></div></vs-td>
        <vs-td class="text-right" style="padding-right: 32px;"><div style="color: white; position: relative; z-index: 999;">{{ actualMonthSum }}€<br/><span style="color: #08B0B9;">{{ actualMonthRefac }}€</span></div></vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
import Purchase from "@/entities/Purchase";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import purchasesMixin from "@/mixins/purchasesMixin";

export default {
	name: "PurchasePopupTable",
	props: {
		contract: Object
	},
	mixins: [dbFieldConvertor, utilsMixin, purchasesMixin],
	computed: {
		today: () => {
			return new Date(Date.now());
		}
	},
	data() {
		return {
			allPurchases: [],
			actualMonthSum: 0,
			actualMonthRefac: 0,
			lastMonthSum: 0,
			lastMonthRefac: 0,
			lastLastMonthSum: 0,
			lastLastMonthRefac: 0,
		};
	},
	watch: {
		allPurchases: function(data) {
		
			this.actualMonthSum = 0;
			this.lastMonthSum = 0;
			this.lastLastMonthSum = 0;
			this.actualMonthRefac = 0;
			this.lastMonthRefac = 0;
			this.lastLastMonthRefac = 0;

			let actual_date = new Date(Date.now());
			let actual_month = actual_date.getMonth();
			let actual_year = actual_date.getFullYear();
			let last_month = (actual_month - 1) < 0 ? 11 : (actual_month - 1);
			let last_year = (actual_month - 1) < 0 ? (Number(actual_year) - 1) : actual_year;
			let last_last_month = (last_month - 1) < 0 ? 11 : (last_month - 1);
			let last_last_year = (last_month - 1) < 0 ? (Number(last_year) - 1) : last_year;

			// let date_last_month = new Date(actual_date);
			// date_last_month.setMonth(actual_date.getMonth() - 1);

			// let date_last_last_month = new Date(actual_date);
			// date_last_last_month.setMonth(actual_date.getMonth() - 2);

			// //console.log("Date + date lastlast:", date_last_month, date_last_last_month);
			for(let purchase of data){
				let purchase_date = purchase.recurrence > 0 ? new Date(purchase.recurrence_date) : new Date(purchase.period_date);
				let purchase_month = purchase_date.getMonth();
				let purchase_year = purchase_date.getFullYear();
				if(actual_year == purchase_year && actual_month == purchase_month){
					let totalAndRefac = this.addTotalHTAndRefac(purchase);
					let total = this.actualMonthSum + totalAndRefac.total;
					let refac = this.actualMonthRefac + totalAndRefac.refac;
					let retTotal = Number.parseFloat(total.toFixed(2));
					let retRefac = Number.parseFloat(refac.toFixed(2));
					this.actualMonthSum = retTotal;
					this.actualMonthRefac = retRefac;
				}

				if(last_year == purchase_year && last_month == purchase_month){
					let totalAndRefac = this.addTotalHTAndRefac(purchase);
					let total = this.lastMonthSum + totalAndRefac.total;
					let refac = this.lastMonthRefac + totalAndRefac.refac;
					let retTotal = Number.parseFloat(total.toFixed(2));
					let retRefac = Number.parseFloat(refac.toFixed(2));
					this.lastMonthSum = retTotal;
					this.lastMonthRefac = retRefac;
				}
				if(last_last_month == purchase_month && last_last_year == purchase_year){
					let totalAndRefac = this.addTotalHTAndRefac(purchase);
					let total = this.lastLastMonthSum + totalAndRefac.total;
					let refac = this.lastLastMonthRefac + totalAndRefac.refac;
					let retTotal = Number.parseFloat(total.toFixed(2));
					let retRefac = Number.parseFloat(refac.toFixed(2));
					this.lastLastMonthSum = retTotal;
					this.lastLastMonthRefac = retRefac;
				}
			}
		}
	},
	created() {
		Purchase.getAllPurchasesWithRecurringForContract(this.$props.contract.id, (err, res) => { // FAIRE UNE FONCTION ALLRC
			if(err) console.error(err);
			if(res){
				this.allPurchases = res.data;
			}
		});
	},
	methods: {
		getRecurrenceCal(recurrence_value, purchase_month){
			let x = 1;
			let cal = [];
			cal.push(x);
			while(x < 12){
				x += recurrence_value;
				cal.push(x);
			}
			for(let month of cal){
				month += (purchase_month - 1);
				if(month > 12) month -= 12;
			}

			return cal;
		},
		getRecurrenceValue(recurrence){
			switch(recurrence) {
			case 1: {
				return 1;
			}
			case 2: {
				return 2;
			}
			case 3: {
				return 3;
			}
			case 4: {
				return 4;
			}
			case 5: {
				return 6;
			}
			case 6: {
				return 12;
			}
			default: {
				return 0;
			}
			}
		},
		computeRecurrence(recurrence, purchase_month, actual_month){
			let recurrence_value = this.getRecurrenceValue(recurrence);
			let cal = this.getRecurrenceCal(recurrence_value, purchase_month);
			return cal.includes(actual_month);
		},
		getYearFromMonth(month){
			let year = month >= 0 ? this.today.getFullYear() : this.today.getFullYear() - 1;
			return year.toString().substring(0, 4);
		},
	}
};
</script>

<style scoped>
.layer-blue {
	display: block;
	position: absolute;
	border-radius: 10px;
	margin-right: 20px;
	right: 0;
	top: 0;
	width: 27%;
	height: 200%;
  	background-color: rgba(12, 41, 61, 0.9);
}
.layer-blue > div {
	display: block;
	position: absolute;
	width: 100%;
	height: 50%;
	border-radius: 10px;
	background-color: #0C293D;
}

.noHover > * {
	pointer-events: none;
}
.center {
  justify-content: center;
}

.b-border {
  border-bottom: 2px solid grey;
}

.r-border {
  border-right: 2px solid grey;
}
.bgcolor {
  background-color: #383080;
}
.white-txt {
  color: white;
}
</style>
